import { useState } from "react";
import "./CategoriesNews.css";

const CATEGORIES = ["Tất cả", "Tin tức", "Kinh nghiệm chăm con"];

// component tạo danh mục tại trang danh sách sản phẩm
const CategoriesNews = (props) => {
  const [active, setActive] = useState("Tất cả");

  const clickHandler = (category) => {
    setActive(category);
    props.onFilter(category);
  };

  return (
    <div className="CN-wrap bg-success text-white pt-3">
      <div className=" ms-3">
        <h5 className="border-bottom pb-2">Danh mục</h5>
        <ul className="CS-ul text-dark">
          {CATEGORIES.map((category, id) => {
            const activeClasses = category === active ? "greencolor" : "";
            return (
              <li
                key={id}
                className={`CS-li ${activeClasses}`}
                onClick={() => clickHandler(category)}
              >
                {category}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default CategoriesNews;
